import axios, { AxiosResponse } from 'axios'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { POST_TYPE } from '../../../models/post'
import { TDuplicatePost } from './types'

// Handle posts
export const duplicatePostsBatchThunk = createAsyncThunk(
  'posts/duplicatePostsBatchThunk',
  async (data: TDuplicatePost[], { getState, rejectWithValue, ...thunkApi }) => {
    try {
      const responsepostDuplicatePost: AxiosResponse<any> = await axios.post(
        `/posts/duplicate-to-any-platform-batch`,
        data
      )
      return responsepostDuplicatePost.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

export const duplicatePostThunk = createAsyncThunk(
  'posts/duplicatePostThunk',
  async (data: TDuplicatePost, { getState, rejectWithValue, ...thunkApi }) => {
    try {
      const url = data.post_id?`/posts/duplicate`:`/posts/duplicate-to-any-platform`
      const responsepostDuplicatePost: AxiosResponse<any> = await axios.post(
        url,
        data
      )
      return responsepostDuplicatePost.data.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

export const getAllowedSocialsToDuplicatePostThunk = createAsyncThunk(
  'posts/getAllowedSocialsToDuplicatePostThunk',
  async (postSocialId: number, { getState, rejectWithValue, ...thunkApi }) => {
    try {
      const responsepostDuplicatePost: AxiosResponse<any> = await axios.get(
        `/post-socials/${postSocialId}/social-networks/allowed`
      )
      return responsepostDuplicatePost.data.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

export const getAllowedToDuplicatePostThunk = createAsyncThunk(
  'posts/getAllowedToDuplicatePostThunk',
  async (postId: number, { getState, rejectWithValue, ...thunkApi }) => {
    try {
      const responsepostDuplicatePost: AxiosResponse<any> = await axios.get(
        `/posts/${postId}/social-networks/allowed`
      )
      return responsepostDuplicatePost.data.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

